import { type SearchResultData } from "~/utils/models";
import { SearchDisplayMode } from "../models/models";
import { getProductData, type ProductData } from "~/domains/product/types/ProductData";
import { useSelector } from "react-redux";
import type { RootState } from "~/app/store";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";
import type { TabularColumnDefDTO } from "~/features/search/models/SearchResultsDTO";
import {
  selectCurrentPage,
  selectProductResults,
  selectResultsPageSize,
} from "~/features/search/redux/searchSelectors";

export function getSelectedProductGroupFromSearchResults(data: SearchResultData) {
  const facetValue = data.facets
    .filter((facet) => facet.code === "categoryPath")
    .flatMap((facet) => facet.values)
    .filter((facetValue) => facetValue.selected)[0];
  return facetValue ? facetValue.code : "";
}

export const FROM_SERIES_TREE_PARAM = "fromSeriesTree";
export const INITAL_TAB_PARAM = "initialTabTabular";

export function getInitialResultsViewMode() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(FROM_SERIES_TREE_PARAM)?.toLowerCase() === "true" ||
    urlParams.get(INITAL_TAB_PARAM)?.toLowerCase() === "true"
    ? SearchDisplayMode.TABULAR
    : SearchDisplayMode.LIST;
}

export const createTabularViewConfiguration = (tabularViewVisibleColumns: TabularColumnDefDTO[]) => {
  return tabularViewVisibleColumns.map((columnDef) => {
    return {
      name: columnDef.abbreviation,
      hoverTitle: columnDef.name,
      techValueUID: columnDef.code,
      sortAsc: columnDef.sortAsc,
      sortDesc: columnDef.sortDesc,
      unit: columnDef.unit ? "(" + columnDef.unit + ")" : null,
      visible: columnDef.isVisible ?? true,
      originalPosition: columnDef.originalPosition,
    };
  });
};

export function useResultTileZoovuParams(product: ProductData | ProductDescriptor) {
  const productData = getProductData(product);

  const index = useSelector((state: RootState) => {
    const results = selectProductResults(state);
    return results.findIndex((row) => row.productCode === productData.code);
  });
  const pageIndex = useSelector(selectCurrentPage);
  const pageSize = useSelector(selectResultsPageSize);

  const position = index + pageIndex * pageSize + 1;

  return {
    ["data-prod-position"]: position,
    ["data-prod-name"]: productData.designation,
    ["data-prod-article"]: productData.hybrisCode,
  };
}
